/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductGroupDto } from '../../models/backend-product-group-dto';
import { BackendProductGroupRequestDto } from '../../models/backend-product-group-request-dto';

export interface SalesGroupsCreate$Params {
  body: BackendProductGroupRequestDto;
}

export function salesGroupsCreate(
  http: HttpClient,
  rootUrl: string,
  params: SalesGroupsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductGroupDto>> {
  const rb = new RequestBuilder(rootUrl, salesGroupsCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductGroupDto>;
    }),
  );
}

salesGroupsCreate.PATH = '/api/sales/groups/';
